import { useStore } from "vuex";
import MerchantFlags from "@/apps/merchant3/types/MerchantFlags";

type ComposableResult = {
  merchantHasFlag: (flag: MerchantFlags) => boolean;
};

export function useMerchantFlags(): ComposableResult {
  const store = useStore();

  const merchantHasFlag = (flag: MerchantFlags): boolean => {
    return store.state.merchant?.merchantFlags?.includes(flag) ?? false;
  };

  return {
    merchantHasFlag,
  };
}
